import { svgColor, svgUri } from '../../helpers'
import { StyleFn } from '..'

const box =
  '<svg width="112" height="112" viewBox="0 0 112 112" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M92.5258 42.4348L103.063 32.1264C104.536 30.6864 104.229 28.2746 102.447 27.2287L70.4463 8.44607C69.1874 7.70714 67.5755 7.90139 66.5372 8.91689L56 19.2251L45.4625 8.91689C44.4244 7.90157 42.8126 7.70695 41.5534 8.44607L9.55294 27.2287C7.76735 28.2766 7.4672 30.6892 8.93653 32.1266L19.4741 42.4348L8.93673 52.7431C7.46452 54.1831 7.77061 56.5949 9.55313 57.641L20.7995 64.2421V82.0871C20.7995 83.1868 21.3894 84.2056 22.3532 84.7713L54.3536 103.554C55.3652 104.148 56.631 104.15 57.6465 103.554L89.6469 84.7711C90.6106 84.2054 91.2004 83.1866 91.2004 82.0869V64.2419L102.447 57.6408C104.232 56.5929 104.532 54.1803 103.063 52.743L92.5258 42.4348ZM69.2963 15.0719L95.6396 30.5343L87.5042 38.4928C86.3692 37.8266 62.2649 23.6786 61.1609 23.0304L69.2963 15.0719ZM81.7804 42.4348L56 57.5666L30.2194 42.4348L56 27.3028L81.7804 42.4348ZM16.3604 30.5347L42.7038 15.0721L50.8392 23.0306C49.7355 23.6784 25.6303 37.8271 24.4958 38.4929L16.3604 30.5347ZM16.3602 54.3348L24.4956 46.3766C25.6309 47.0428 49.735 61.1908 50.839 61.839L42.7036 69.7974L16.3602 54.3348ZM84.8002 80.3144L56 97.2187L27.1784 80.3144V67.9985L41.5536 76.4236C42.8126 77.1626 44.4244 76.9683 45.4627 75.9528L56 65.6444L66.5376 75.9528C67.5768 76.9694 69.189 77.162 70.4467 76.4236L84.8004 67.9985L84.8002 80.3144ZM69.2961 69.7972L61.1607 61.8388C62.2644 61.1909 86.3696 47.0422 87.5041 46.3762L95.6394 54.3346L69.2961 69.7972Z" fill="#E0E3E9"/></svg>'

export const IconArrowDownward = {
  data: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="m8 14 4 4 4-4" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 18V6" stroke="#000000" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"></path></g></svg>',
}

export const Table: StyleFn = ({ asset, font, color, size }) => {
  const resizerGrip = {
    content: "''",
    position: 'absolute',
    width: size.spacing[8],
    height: '100%',
    top: 0,
    bottom: 0,
  }

  return {
    root: {
      width: '100%',
      height: '100%',
      display: 'table',
      tableLayout: 'fixed',
      position: 'relative',
      textAlign: 'left',
      verticalAlign: 'middle',
      fontSize: font.size.small,
      backgroundColor: color.getModalValues(color.background.primary),
      color: color.getModalValues(color.text.primary),
      borderSpacing: 0,
      borderCollapse: 'collapse',
      borderRadius: '3px',
      // force default display for native html table elements
      '& td, & th': {
        display: 'table-cell !important',
      },
    },
    container: {
      width: '100%',
      height: '100%',
    },
    _condensed: {
      '& $head': {
        minHeight: size.spacing[40],
        '& $row, &:before, &:after': {
          height: size.spacing[40],
        },
      },
      '& $row': {
        height: size.spacing[32],
      },
      '& $cell': {
        '@supports (-webkit-line-clamp: 2)': {
          display: 'block',
          whiteSpace: 'nowrap',
        },
      },
    },
    head: {
      position: 'relative',
      minHeight: size.spacing[48],
      color: color.text.emphasis,
      backgroundColor: color.getModalValues(color.neutral.light),
      boxShadow: '0 1px 4px 0 rgba(0,0,0,0.20)',
      clipPath: 'inset(-4px -4px 0px -4px)',
      overflow: 'hidden',
      '& $row': {
        height: size.spacing[48],
        boxShadow: `inset 0 -1px 0 ${color.getModalValues(color.border.control)}`,
      },
    },
    body: {
      minHeight: size.spacing[40],
      overflow: 'auto',
      boxShadow: '0 1px 4px 0 rgba(0,0,0,0.20)',
      clipPath: 'inset(0px -4px -4px -4px)',
      '& $row:first-child': { boxShadow: 'none' },
      '& $body': {
        boxShadow: 'none',
      },
    },
    row: {
      boxSizing: 'border-box',
      height: size.spacing[40],
      '&:hover': {
        backgroundColor: color.getModalValues(color.neutral.light),
      },
      '&:nth-of-type(even):not(:hover)': {
        backgroundColor: color.getModalValues(color.neutral.lighter),
      },
    },
    row_dividers: {
      boxShadow: `0px 1px 0px inset ${color.palette.coolgrey[20]}`,
    },
    row_clickable: {
      cursor: 'pointer',
    },
    row_expanded: {
      position: 'relative',
      padding: `${size.spacing[8]} ${size.spacing[16]}`,
      '&:nth-of-type(odd)': {
        backgroundColor: color.getModalValues(color.neutral.lighter),
      },
    },
    row_expanded_even: {
      display: 'none',
    },
    row_selected: {
      '& + $row_selected': {
        boxShadow: `0 1px 0 0 ${color.palette.white} inset`,
      },
      // FIXME migrate to figma surface.neutral.active token
      // increase specificity
      '$row_selected&:not(:hover)': {
        backgroundColor: '#E5ECF7',
      },
      '&:nth-of-type(even):not(:hover)': {
        backgroundColor: '#E5ECF7',
      },
    },
    cell: {
      padding: `0 ${size.spacing[16]}`,
      margin: 'auto 0',
      lineHeight: font.lineheight.xxsmall,
      // limit content to one line with ellipsis
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      // // two lines for browsers that support line-clamp
      '@supports (-webkit-line-clamp: 2)': {
        whiteSpace: 'initial',
        display: '-webkit-box',
        boxOrient: 'vertical',
        lineClamp: 2,
      },
    },
    cell_head: {
      display: 'flex',
      alignItems: 'center',
      padding: `${size.spacing[8]} ${size.spacing[16]}`,
      lineHeight: font.lineheight.xxsmall,
      position: 'relative',
      fontWeight: font.weight.medium,
      '&:hover $resizer': {
        opacity: 1,
      },
      // needed because of resizer invisible grip
      '&:last-child': {
        overflow: 'hidden',
      },
    },
    cell_right: {
      textAlign: 'right',
      justifyContent: 'flex-end',
    },
    cell_checkbox: {
      padding: size.spacing[8],
      paddingTop: size.spacing[10],
      paddingLeft: size.spacing[12],
      width: size.spacing[40],
      flex: 'unset !important',
    },
    cell_expand: {
      padding: size.spacing[8],
      width: size.spacing[40],
    },
    expandBtn: {},
    expandBtn_collapse: {
      transform: 'rotate(180deg)',
    },
    empty: {
      paddingTop: size.spacing[128],
      marginBottom: size.spacing[16],
      backgroundImage: svgUri(box, true),
      backgroundRepeat: 'no-repeat',
      backgroundPosition: `center ${size.spacing[16]}`,
      backgroundSize: size.spacing[112],
      textAlign: 'center',
      fontSize: font.size['heading-6'],
      color: color.getModalValues(color.text.tertiary),
      '& > *': { marginTop: size.spacing[16], marginBottom: 0 },
    },
    loading: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#00000020',
    },
    pagination: {
      paddingTop: size.spacing[16],
    },
    resizer: {
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 1,
      background: color.brand.lighter,
      width: 1,
      height: '100%',
      cursor: 'ew-resize',
      /* prevents from scrolling while dragging on touch devices */
      touchAction: 'none',
      opacity: 0,
      '&:hover': {
        width: size.spacing[4],
        right: -1,
      },
      '&:before': {
        ...resizerGrip,
        left: `calc(-${size.spacing[8]})`,
      },
      '&:after': {
        ...resizerGrip,
        right: `calc(-${size.spacing[8]})`,
      },
    },
    resizer_resizing: {
      opacity: 1,
      width: size.spacing[4],
      right: -1,
    },
  }
}

export const SortLabel: StyleFn = ({ font, color, size }) => {
  const bgSvgColor = color.type === 'light' ? color.palette.primaryblue['60'] : color.palette.white

  return {
    root: {
      color: color.text.emphasis,
      fontWeight: font.weight.medium,
      fontSize: font.size.small,
      position: 'relative',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      textOverflow: 'hidden',
      '&:hover $arrow:before': {
        opacity: 1,
      },
    },
    arrow: {
      position: 'relative',
      width: size.spacing[16],
      height: size.spacing[16],
      marginLeft: size.spacing[8],
      '&:before': {
        position: 'absolute',
        content: "''",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundSize: size.spacing[16],
        backgroundPosition: 'center center',
        backgroundImage: svgUri(svgColor(IconArrowDownward.data, color.palette.coolgrey[60])),
        opacity: 0,
        transition: 'opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      },
    },
    index: {
      fontSize: '0.625rem',
      color: color.brand.light,
      position: 'absolute',
      top: `calc(-${size.spacing[8]})`,
      right: `calc(-${size.spacing[6]})`,
    },
    _right: {
      flexDirection: 'row-reverse',
      '& $arrow': {
        marginLeft: 0,
        marginRight: size.spacing[8],
      },
      '& $index': {
        left: `calc(-${size.spacing[6]})`,
        right: 'auto',
      },
    },
    _active: {
      fontWeight: font.weight.bold,
      '& $arrow:before': {
        backgroundImage: svgUri(svgColor(IconArrowDownward.data, bgSvgColor)),
        opacity: 1,
      },
    },
    _asc: {
      '& $arrow:before': {
        transform: 'rotate(180deg)',
      },
    },
  }
}
